import styles from "./SubmissionLoader.module.scss"
const SubmissionLoader = ({ color = "#FFF", width = "60px" }) => {
  return <>
    <div className={styles.screenOverlay}></div>
    <div className={styles.loaderWrapper}>
      <div className={styles.dotLoader} style={{
        '--loader-color': color,
        '--loader-width': width
      }}>
      </div>
    </div>
  </>
}

export default SubmissionLoader